import { useCallback } from 'react'

import configurationServices from '@/configuration/services/services'

import { getRecommendedProductsParams } from './helpers'
import {
  transformRequestGetOrderTrackingPreviewRecommendedProducts,
  transformResponseOrderTrackingPreviewRecommendedProducts,
} from './transformers'

const useRecommendedProductsService = ({ storeId, isRealOrder }) => {
  const getRecommendedProductsService = useCallback(
    async (recommendationParams, config) => {
      const recommendedProductsParams = getRecommendedProductsParams(recommendationParams)
      const params = transformRequestGetOrderTrackingPreviewRecommendedProducts(recommendedProductsParams)

      if (isRealOrder) {
        const response = await configurationServices.getOrderTrackingPreviewOrderRecommendedProducts(
          { storeId, orderId: recommendationParams.orderId, params },
          config
        )

        return { data: transformResponseOrderTrackingPreviewRecommendedProducts(response.data) }
      }

      const response = await configurationServices.getOrderTrackingPreviewRecommendedProducts(
        { storeId, params },
        config
      )

      return { data: transformResponseOrderTrackingPreviewRecommendedProducts(response.data) }
    },
    [isRealOrder, storeId]
  )

  return { getRecommendedProductsService }
}

export default useRecommendedProductsService
